import { Theme, createStyles } from '@material-ui/core';
const styles = (theme: Theme) =>
createStyles({
  root: {
    "&$checked": {
      color: "#1D7DEA !important",
    },
    "& label.MuiFormLabel-root": {
      fontSize: "1rem",
      color: "#33333",
    },
    "& p, a": {
      color: "#33333",
      fontSize: "1rem",
    },
  },
  doneBtn: {
    marginTop: 20,
  },
  mb1x: {
    marginBottom: theme.spacing.unit,
  },
  formControllContainer: {
    ...theme.mixins.gutters(),
    paddingTop: theme.spacing.unit * 2,
  },
  fontSizeLG: {
    fontSize: "1.75rem",
  },
  fontSizeMD: {
    fontSize: "1rem",
  },
  fontWeight500: {
    fontWeight: 500,
  },
  cardContainer: {
    border: "1px solid #E1E1E1",
    borderRadius: 4,
  },
  modal: {
    display: "flex",
    padding: 12,
    alignItems: "center",
    justifyContent: "center",
    borderRadius: 4,
  },
  paper: {
    width: 680,
    backgroundColor: "#fff",
    boxShadow: theme.shadows[5],
    padding: "20, 40, 30",
    borderRadius: 4,
    outline: "#fff",
  },
  modalHeader: {
    height: 66,
    borderBottom: "1px solid #E2E2E2",
    background: "#fff",
    backgroundColor: "#fff",
  },  
  mxWidth500:{
    maxWidth: 500,
  },
  text: {
    display: "flex",
    justifyContent: "space-between"
  },
  headingText:{
    fontSize: 16,
    fontWeight: 400,
    color: '#666',
    marginBottom: 36,
  },
  inputLabel:{
    fontSize: 16,
    fontWeight: 600,
    color: '#666',
  },
  normalLabel:{
    fontSize: 16,
    fontWeight: 400,
    color: '#999',
    marginTop:8,
    marginRight:8,
  },
  modalfooter: {
    height: 66,
    borderTop: "1px solid #E2E2E2",
    background: "#fff",
    backgroundColor: "#fff",
    padding: '7px 40px 14px 20px',
    '& button':{
      padding: "0 25px",
    }
  },
  customFieldInput:{
    marginRight: 80,
    '& input':{
      width: 95,
      height: 30,
    },
    '&>div:nth-of-type(1)':{
      marginBottom: 0,
    }
  },
  font16:{
    fontSize: 20,
    fontWeight: 'bold',
  },
  m0:{
    margin: 0,
  }
});

export { styles };